import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { DataTestType } from '@y42/data-test';
import { DatasourceColumnModelMeta, sourceColumnConstants } from '@y42/datasource/shared/function-editor';
import { TypescriptTypeEnum } from '@y42/monaco-typescript-types';
import { startWith } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataTestBuilderFormService } from '../../data-test-builder-form.service';
import { DataTestBuilderService } from '../../data-test-builder.service';

@UntilDestroy()
@Component({
  selector: 'y42-low-code-test',
  templateUrl: './low-code-test.component.html',
  styleUrls: ['./low-code-test.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LowCodeTestComponent {
  constructor(
    private readonly dataTestBuilderFormService: DataTestBuilderFormService,
    private readonly dataTestBuilderService: DataTestBuilderService,
  ) {}

  readonly allowedOutputTypes: TypescriptTypeEnum[] = [TypescriptTypeEnum.BOOLEAN];
  readonly formGroup = this.dataTestBuilderFormService.getFormByTestType(DataTestType.LowCode);
  readonly thresholdFormArguments = {
    rowsFailedByConditionControl: this.formGroup.controls.rows_failed_by_condition,
    rowsFailedConditionControl: this.formGroup.controls.rows_failed_condition,
  };

  readonly state = connectState(this, {
    sourceColumns: this.dataTestBuilderService.allSchemaTestColumns$.pipe(
      map((columns) =>
        columns.map(
          (column): DatasourceColumnModelMeta => ({
            data_type: column.type,
            field_name: column.column,
          }),
        ),
      ),
      map((columns) => sourceColumnConstants(columns)),
    ),
    isRelative: this.formGroup.controls.rows_failed_condition.valueChanges.pipe(
      startWith(this.formGroup.controls.rows_failed_condition.value),
      map((x) => x === 'relative'),
    ),
  });

  editorValueChanged($event: string) {
    this.formGroup.controls.low_code_string.patchValue($event ?? '');
  }

  editorValidityChanged($event: boolean) {
    const errors = $event ? null : { lowCodeError: true };
    this.formGroup.controls.low_code_string.setErrors(errors);
  }
}
